(function () {
  'use strict';

  function setInitialRailPosition() {
    var rail = document.querySelector('.cp-featured__books');
    if (!rail) return;
    var previousBehavior = rail.style.scrollBehavior;

    rail.style.scrollBehavior = 'auto';
    rail.scrollLeft = 0;
    rail.style.scrollBehavior = previousBehavior;
  }

  function restoreViewAllLink() {
    var featured = document.querySelector('.cp-featured');
    var button = featured && featured.querySelector('.cp-button--wide');
    if (!button) return;

    featured.classList.remove('is-expanded');
    button.removeAttribute('role');
    button.removeAttribute('aria-expanded');
  }

  function initialize() {
    restoreViewAllLink();
    setInitialRailPosition();
    window.requestAnimationFrame(setInitialRailPosition);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  window.addEventListener('pageshow', initialize);
  document.addEventListener('shopify:section:load', initialize);
}());
